import { styled } from '@mui/material/styles';

export const ActionsContainer = styled('div')({
  display: 'flex',
  gap: '10px',
});
